var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatePicker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 9.00016C1.6665 5.85766 1.6665 4.286 2.64317 3.31016C3.61984 2.33433 5.19067 2.3335 8.33317 2.3335H11.6665C14.809 2.3335 16.3807 2.3335 17.3565 3.31016C18.3323 4.28683 18.3332 5.85766 18.3332 9.00016V10.6668C18.3332 13.8093 18.3332 15.381 17.3565 16.3568C16.3798 17.3327 14.809 17.3335 11.6665 17.3335H8.33317C5.19067 17.3335 3.619 17.3335 2.64317 16.3568C1.66734 15.3802 1.6665 13.8093 1.6665 10.6668V9.00016Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 2.3335V1.0835M14.1663 2.3335V1.0835",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.0835L8.75 9.8335V13.1668",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08301 6.5H17.9163M10.833 12.3333V10.6667C10.833 10.4457 10.9208 10.2337 11.0771 10.0774C11.2334 9.92113 11.4453 9.83333 11.6663 9.83333C11.8874 9.83333 12.0993 9.92113 12.2556 10.0774C12.4119 10.2337 12.4997 10.4457 12.4997 10.6667V12.3333C12.4997 12.5543 12.4119 12.7663 12.2556 12.9226C12.0993 13.0789 11.8874 13.1667 11.6663 13.1667C11.4453 13.1667 11.2334 13.0789 11.0771 12.9226C10.9208 12.7663 10.833 12.5543 10.833 12.3333Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatePicker);
export default __webpack_public_path__ + "static/media/DatePicker.c4996ad8d34030bf98f9f3064fe3e8ec.svg";
export { ForwardRef as ReactComponent };